import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Popover from "@material-ui/core/Popover/Popover";
import Box from "@material-ui/core/Box/Box";
import TextFieldsRoundedIcon from '@material-ui/icons/TextFieldsRounded';
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import {Translate} from "../../../../config/Translate";
import {defaultVariabls} from "../../../../config";
import MenuBookTwoToneIcon from '@material-ui/icons/MenuBookTwoTone';
class ReaderLoader extends React.Component {
    state = {

    };
    classes = this.props.classes;

    render(){
        return (
            <div style={{
                display:"flex",
                flexDirection:'column',
                width:"100vw",
                height:"100vh",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <MenuBookTwoToneIcon  style={{fontSize:40,marginBottom:20}} />
                <img
                    style={{width:80,display:"block",marginBottom:10}}
                    src={`${defaultVariabls.website}/images/epanjere/panjere-logo.png`}
                    alt={Translate.appName}
                />
                <div className="loader-search">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(ReaderLoader))));